import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ModalCommunicationService {
    private searchUserListsSubject = new Subject<void>();

    // Observable for components to subscribe to
    searchUserLists$ = this.searchUserListsSubject.asObservable();

    // Method to trigger searchUserLists
    triggerSearchUserLists() {
        this.searchUserListsSubject.next();
    }
}

